import type { DeepPartial, Theme } from "@chakra-ui/react";

/** extend additional color here */
const extendedColors: DeepPartial<
  Record<string, Theme["colors"]["blackAlpha"]>
> = {
  brand: {
    100: "",
    200: "",
    300: "",
    400: "",
    500: "",
    600: "",
    700: "",
    800: "",
    900: "",
  },
};

/** override chakra colors here */
const overridenChakraColors: DeepPartial<Theme["colors"]> = {
  // overrides for chakra alert status info used in toast
  blue: {
    100: "#ECFAF5",
    500: "#308D8A",
  },
  green: {
    100: "#ECFAF5",
    500: "#308D8A",
  },
  orange: {
    100: "#FDF3E6",
    500: "#EB8302",
  },
  red: {
    100: "#FDEEEB",
    500: "#E2543D",
  },
  gray: {
    50: "#F7FAFC",
    100: "#EDF2F7",
    200: "#E2E8F0",
    300: "#CBD5E0",
  },
};

const colors = {
  ...overridenChakraColors,
  ...extendedColors,
  black: "#171923",
  black600: "#17192399",
  blackMate: "#242731",
  blackMate800: "#242731CC",
  greenLight: "#C8ECE1",
  greenVibrant: "#08B898",
  greenVibrant800: "#08B898CC",
  marinadeGreen: "#308D8A",
  marinadeLightGreen: "#E6F8F5",
  marinadeLigherGreen: "#08B886",
  marinadeOrange: "#EB8302",
  marinadePumpkinOrange: "#F25700",
  marinadeLightOrange: "#FDF3E6",
  green800: "#308D8ACC",
  marinadeLighterGreen: "#DFF4ED",
  marinadeEvenLighterGreen: "#ECFAF5",
  marinadeBorderGreen: "#98D7C3",
  marinadeDarkRed: "#CF371E",
  marinadeRed: "#E2543D",
  marinadeLightRed: "#FCEEEC",
  marinadePink: "#D47AAF",
  white: "#FFFFFF",
  white800: "#FFFFFFCC",
  iceGray: "#D8DEEB",
  lightGray: "#EDF2F7",
  lighterGray: "#F7FAFC",
  lightsmokeGray: "#F5F5F5",
  veryLightGray: "#CCCCCC",
  mediumGray: "#8596A1",
  darkGray: "#4A5568",
  darkGrayLighter: "#718096",
  darkGraySecondary: "#353841",
  marinadeOrange400: "#F0700066",
  marinadeOrange600: "#D64609",
  marinadeDarkOrange: "#98590C",
  marinadeDarkYellow: "#DFB542",
  marinadeAmber: "#FFB65C",
  marinadeDarkerRed: "#B82908",
  marinadeYellow: "#FFC116",
  marinadePeach: "#FF8754",
  marinadePurple: "#8D2BFF",
  marinadeLightYellow: "#EBB802",
  marinadeBlue: "#4299E1",
  marinadeLightBlue: "#2B8CFF",
  marinadeDarkBlue: "#30668D",
  treeMap0: "#21615E",
  treeMap1: "#2B7875",
  treeMap2: "#308D8A",
  treeMap3: "#98D7C3",
  treeMapBase: "#C8ECE1",
  transaparent: "transparent",
  palette: [
    "#B794F4",
    "#08B898",
    "#EB8302",
    "#4299E1",
    "#C8ECE1",
    "#FFC116",
    "#F687B3",
    "#68D391",
    "#4FD1C5",
  ],
};

export default colors;
